import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    card: { marginBottom: theme.spacing(5) },
    cardContent: { display: "flex", gap: theme.spacing(2), "&.MuiCardContent-root": { paddingTop: 0 } },
    idCell: { maxWidth: 200 },
    cardTitleBox: { display: "flex", gap: theme.spacing(2), alignItems: "flex-end" },
    cell: { width: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    sizeCell: { width: 100, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
    actionCell: { display: "flex", gap: theme.spacing(1), justifyContent: "flex-end" },
    flex: { display: "flex", gap: theme.spacing(1) },
    boldLabel: {
        "&.MuiTypography-body1": { fontWeight: 600 },
    },
}));
